export const SAVE_DAILY_DATA = "SAVE_DAILY_DATA";
export const SAVE_PHONE_NUMBER = "SAVE_PHONE_NUMBER";
export const SAVE_EMPLOYEE_NAME = "SAVE_EMPLOYEE_NAME";
export const SAVE_OUTLET_NAME = "SAVE_OUTLET_NAME";
